import { useTheme } from "@mui/material";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const Sales: React.FC<SvgIconProps> = (props) => {
  const theme = useTheme();

  return (
    <SvgIcon
      {...props}
      width="24"
      height="10"
      viewBox="0 0 24 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3413_604)">
        <path
          d="M11 10H7C5.61667 10 4.43767 9.51233 3.463 8.537C2.48833 7.56167 2.00067 6.38267 2 5C1.99933 3.61733 2.487 2.43833 3.463 1.463C4.439 0.487667 5.618 0 7 0H11V2H7C6.16667 2 5.45833 2.29167 4.875 2.875C4.29167 3.45833 4 4.16667 4 5C4 5.83333 4.29167 6.54167 4.875 7.125C5.45833 7.70833 6.16667 8 7 8H11V10ZM8 6V4H16V6H8ZM13 10V8H17C17.8333 8 18.5417 7.70833 19.125 7.125C19.7083 6.54167 20 5.83333 20 5C20 4.16667 19.7083 3.45833 19.125 2.875C18.5417 2.29167 17.8333 2 17 2H13V0H17C18.3833 0 19.5627 0.487667 20.538 1.463C21.5133 2.43833 22.0007 3.61733 22 5C21.9993 6.38267 21.5117 7.562 20.537 8.538C19.5623 9.514 18.3833 10.0013 17 10H13Z"
          fill={theme.palette.brandedTypography.textColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_3413_604">
          <rect width="24" height="10" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default Sales;
